import { render, staticRenderFns } from "./ConfigurationEditPage.vue?vue&type=template&id=24541237&scoped=true&"
import script from "./ConfigurationEditPage.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationEditPage.vue?vue&type=style&index=0&id=24541237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24541237",
  null
  
)

export default component.exports